export default __webpack_public_path__ + "static/media/ar4i.c85c2e7c.png";